module.exports = __webpack_public_path__ + "img/pigs.2bc4716b.png";